(ns very.re-frame.specs
  (:require [cljs.spec.alpha :as s]))

(s/def ::event-vec (s/cat :event-type keyword? :extra-args (s/* any?)))
(s/def ::dispatch-vector (s/or :single ::event-vec
                               :multiple (s/coll-of ::event-vec
                                                    :kind vector?
                                                    :min-count 1)))
